import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../apis/axios";
import { getToken } from "../utilities";

function useCreate({
  refreshUrl = "",
  url = "",
  onSuccess,
  onError,
  responseAsBlob = false,
  stringifyValues = true,
} = {}) {
  const queryClient = useQueryClient();
  const setDataToServer = useMutation((data) => setUsers(data), {
    onError: (err) => {
      onError?.(err);
    },
    onSuccess: (data, reqParams) => {
      if (refreshUrl) queryClient.invalidateQueries([refreshUrl]);
      onSuccess?.(data, reqParams);
    },
  });
  const setUsers = async (getFormData) => {
    let fd = new FormData();
    for (var key in getFormData) {
      if (key === "published_at") {
      }
      if (
        (Array.isArray(getFormData[key]) ||
          typeof getFormData[key] === "object") &&
        typeof getFormData[key] !== "string" &&
        stringifyValues
      ) {
        fd.append(key, JSON.stringify(getFormData[key]));
      } else {
        fd.append(key, getFormData[key]);
      }
    }
    const response = await axios({
      method: "POST",
      data: fd,
      url: `/${url}`,
      responseType: responseAsBlob ? "blob" : undefined,
      headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
    });
    return response.data;
  };
  return { setDataToServer };
}

export default useCreate;
